import AssessmentOutlined from "@mui/icons-material/AssessmentOutlined";
import DynamicFeedOutlined from "@mui/icons-material/DynamicFeedOutlined";
import ListAltOutlined from "@mui/icons-material/ListAltOutlined";
import {lazy} from "react";
import exportsRoutes from "router/routes/exports";
import type {Page, PageGroup} from "router/types";
import {ROLE_ADMIN, ROLE_SUPER_ADMIN, ROLE_USER} from "utils/roles";

const MessageBatchesPage = lazy(
  () => import("pages/message-report/message-batches/MessageBatchesPage"),
);
const MessagesPage = lazy(
  () => import("pages/message-report/messages/MessagesPage"),
);

const messageReport: Array<Page | PageGroup> = [
  {
    segment: "message-report",
    title: "Message Report",
    Icon: AssessmentOutlined,
    children: [
      {
        segment: "message-batches",
        title: "Message Batches",
        Icon: DynamicFeedOutlined,
        Component: MessageBatchesPage,
        roles: [ROLE_SUPER_ADMIN, ROLE_ADMIN, ROLE_USER],
      },
      {
        segment: "messages",
        title: "Messages",
        Icon: ListAltOutlined,
        Component: MessagesPage,
      },
      ...exportsRoutes,
    ],
  },
];

export default messageReport;
